export default {"src":"/_next/static/media/relax-icon.a6753418.svg","height":160,"width":185,"blurWidth":0,"blurHeight":0};